import React, { memo, useEffect, useRef } from "react";
import { MAP_HTML, startScene } from "./trackingScene";
import styles from "./style.module.css";

// No props and memoised: the injected SVG must never be re-rendered, or the
// animation loop would keep writing to detached nodes.
const TrackingMap = () => {
  const ref = useRef(null);

  useEffect(() => startScene(ref.current), []);

  return (
    <div className={styles.mapCard}>
      {/* Decorative demo: hidden so screen readers don't announce its sample status as the buyer's own. */}
      <div ref={ref} className={styles.mapArt} aria-hidden="true" dangerouslySetInnerHTML={{ __html: MAP_HTML }} />
    </div>
  );
};

export default memo(TrackingMap);
